export default __webpack_public_path__ + "static/media/ReadyStreel.f5515bf6.png";